export const imagenAnerior = ({ listadoImagenes, posicion, setPosicion }) => posicion === listadoImagenes.length - 1 ? setPosicion(0) : setPosicion(posicion + 1)

export const imagenSiguiente = ({ listadoImagenes, posicion, setPosicion, reproduciendo }) => {
    posicion === 0 ? setPosicion(listadoImagenes.length - 1) : setPosicion(posicion - 1)
}



export const pause = ({ idReproduccion, setReproduciendo }) => clearInterval(idReproduccion, setReproduciendo(0))
export const reproducir = ({ reproduciendo, setReproduciendo }) => { if (reproduciendo === 0) setReproduciendo(1) }
export const stop = ({ idReproduccion, setReproduciendo, setPosicion, setIdReproduccion }) => clearInterval(idReproduccion, setReproduciendo(0, setPosicion(0, setIdReproduccion(0))))
